import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

import AccordionSlice from "~/components/AccordionSlice";
import Wrapper from "~/components/SliceWrapper";

export type AccordionProps = SliceComponentProps<Content.AccordionSlice>;

const Accordion: FC<AccordionProps> = ({ slice }) => {
  return (
    // @ts-expect-error — SliceWrapper is an untyped JS component
    <Wrapper data-analytics-component="accordion" slice={slice}>
      <AccordionSlice slice={slice} />
    </Wrapper>
  );
};

export default Accordion;
